import { useParams } from 'react-router-dom';
import { useGetZendeskChatWidgetsQuery } from 'src/services';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { WebWidgetSelect } from 'src/components/Integrations/EditIntegrationPopup/EditIntegrationSettings/EditZendeskChatIntegrationSettings/EditZendeskChatWidgetSettings/WebWidgetSelect';
import Input from 'src/components/Input/Input';
import { Skeleton } from 'src/components/ui/skeleton';

const LoadingBlock = () => (
  <div className={'w-full flex flex-col gap-2.5 p-2.5 bg-[#A498FF1A] rounded-sm-5'}>
    <Skeleton className={'w-1/3 h-4'} />
    <Skeleton className={'w-full h-12'} />
    <Skeleton className={'w-1/3 h-4'} />
    <Skeleton className={'w-full h-12'} />
    <Skeleton className={'w-1/3 h-4'} />
    <Skeleton className={'w-full h-12'} />
  </div>
);

export const EditZendeskChatWidgetSettings = ({ integration }) => {
  const { id } = useParams();
  const { data: widgets, isFetching: widgetsIsFetching } = useGetZendeskChatWidgetsQuery({
    projectId: id,
    integrationId: integration.id,
  }) as any;
  const { control } = useFormContext();
  const isSetup = integration?.integration_data?.is_setup;

  return widgetsIsFetching ? (
    <LoadingBlock />
  ) : (
    <div className={'w-full flex flex-col gap-2.5 p-2.5 bg-[#A498FF1A] rounded-sm-5'}>
      {!isSetup && (
        <div>
          <WebWidgetSelect
            label={<div className={'flex flex-row gap-2 items-center mb-1'}>Web Widget</div>}
            control={control}
            name={'widget_integration_id'}
            options={widgets || []}
          />
        </div>
      )}
      <div>
        <Controller
          control={control}
          name="author_display_name"
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <Input
              type={'text'}
              label={'AI Name'}
              placeholder={'AI Assistant'}
              invalidMessage={error?.message}
              value={value}
              isValid={!error?.message}
              onChange={onChange}
              className={'!text-sm'}
              autoFocus={true}
              infoTooltip={{
                side: 'right',
                description: 'AI name that will be visible to customers.',
              }}
            />
          )}
        />
      </div>
      <div>
        <Controller
          control={control}
          name="welcome_message"
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <Input
              type={'text'}
              label={'AI Welcome message'}
              placeholder={'Hello! How can I help you?'}
              invalidMessage={error?.message}
              value={value}
              isValid={!error?.message}
              onChange={onChange}
              infoTooltip={{
                side: 'right',
                description: (
                  <>
                    The first message AI will send <br /> once a chat widget is opened.
                  </>
                ),
              }}
            />
          )}
        />
      </div>
    </div>
  );
};
